import {css} from '@emotion/react'

const btn = css`
	color: grey;
	min-width: 0;
	margin: 0 4px;
	padding: 2px;
`
const stack = css`
	color: grey;
	min-width: 0;
	margin: 0 4px;
	padding: 0;
	height: 18px;
`
const stackWrapper = css`
	display: inline-block;
	padding-left: 2px;
`
export const cssCFButton = {btn, stack, stackWrapper}